// extracted by mini-css-extract-plugin
export default {"header":"ServiceCategory_header__1o0hA","icon":"ServiceCategory_icon__RO1UC"};